import BaseController from '@humandigital-agency/base-controller';

import styleFileInput from 'style-file-input';

class CustomForm {
    constructor(form) {
        this.form = form;
        console.log(this.form);
    }

    init() {
        if (this.form.querySelector('input[type="file"]')) {
            this.initFileStyling();

            if (this.form.closest && this.form.closest('.vacancyForm')) {
                this.initVacancyForm();
            }
        }
    }

    initFileStyling() {
        this.form.querySelectorAll(`input[type="file"]`).forEach((input, index) => {
            const instance = styleFileInput(input, {
                browseButtonLabel: `Bladeren`,
                changeButtonLabel: `Bladeren`,
                noFileSelectedText: input.getAttribute(`placeholder`) || `Geen bestand`,
            });
            input.styleObject = instance;
        });
    }

    initVacancyForm() {
        this.vacancyOtherID = '6256';

        if (this.form.querySelector('#SourceNodeElse')) {
            let elseRow = this.form.querySelector('#SourceNodeElse').closest('.inputRow');
            let sourceSelect = this.form.querySelector(`select[name="SourceNode"]`);

            if (sourceSelect && elseRow && Array.from(sourceSelect.querySelectorAll('option')).filter(option => option.value == this.vacancyOtherID)) {
                
                const onChange = () => {
                    let otherOption = Array.from(sourceSelect.querySelectorAll('option')).filter(option => option.value == this.vacancyOtherID)[0];
                    if (otherOption.selected) {
                        elseRow.classList.remove('d-none');
                        elseRow.querySelector('input').focus();
                        elseRow.previousElementSibling.classList.add('mb-1');
                        elseRow.previousElementSibling.classList.remove('mb-6');
                    } else {
                        elseRow.classList.add('d-none');
                        elseRow.querySelector('input').blur();
                        elseRow.previousElementSibling.classList.add('mb-6');
                        elseRow.previousElementSibling.classList.remove('mb-1');
                    }
                }
                onChange();

                sourceSelect.addEventListener('change', onChange);
            }
        }
    }
}

export default class FormController extends BaseController {
    constructor() {
        super(`.formWrapper form`, CustomForm);
    }
}